import { ServerConfig } from '../choo-app/types'

export const getConfigFromWindow = (): ServerConfig => {
  return window.scripto.config
}
